import React, { Fragment } from 'react'
import { Note } from '@myxplor/ui'
import { FormDate, FormTextArea } from '@myxplor/forms'

export const UpdateStartDateFields = ({ onChange, errors, values }) => (
  <Fragment>
    <Note important>
      Legally, the start date for an enrolment may only be backdated to the date that a
      parent&#x27;s written approval was signed. It cannot be backdated to prior to that, and not
      before 2 July 2018, whichever is later.
    </Note>

    <fieldset>
      <FormDate
        name="startDate"
        label="Start Date"
        value={values.startDate}
        errors={errors.startDate}
        onChange={onChange}
        required
      />

      <FormTextArea
        name="lateSubmissionReason"
        label="Reason for Backdating the enrolment"
        value={values.reason}
        errors={errors.reason}
        onChange={onChange}
        maxLength={1000}
        rows={2}
      />
    </fieldset>
  </Fragment>
)

export const UpdateStartDateDone = () => (
  <Fragment>The enrolment has been successfully backdated</Fragment>
)



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/actions/update-start-date/fields.jsx